import React from 'react';
import UploadCatalogoFornecedor from '../UploadCatalogoFornecedor/UploadCatalogoFornecedor';

type Props = { closeAction: Function; closeActionSimple: Function };

const UploadFoodZap: React.FC<Props> = (props) => <UploadCatalogoFornecedor {...props}
  source="FOODZAP" title="Importar catálogo FoodZap"
  instructions="Copie a URL completa do cardápio digital da sua loja na FoodZap."
  placeholder="https://foodzap.app.br/menu/sua-loja" />;

export default UploadFoodZap;
